import get from 'lodash/get'
import queryString from 'query-string'
import { EditionType } from '@graphics/gfx-common/dist/constants'
import { IGroup, IGroupInput, IGroupDetailed } from '../types/group'
import { ICapabilitiesSummaryRaw } from '../types/capabilitiesSummary'
import { safePost, safeGet, safePut, safeDelete, groupsHostUrl } from './http'

const groupUrl = `${groupsHostUrl}/groups`

export const getGroups = (): Promise<IGroup[]> => safeGet(groupUrl)

export const getGroupsDetailed = (): Promise<IGroupDetailed[]> =>
  safeGet(`${groupsHostUrl}/groups-detailed`)
export const createGroup = (groupData: IGroupDetailed) =>
  safePost(groupUrl, groupData)
export const getGroupById = (groupId: string) =>
  safeGet(`${groupUrl}/${groupId}`)
export const getGroupEditors = (groupId: string, query: any) =>
  safeGet(
    `${groupUrl}/${groupId}/roles/editors?${queryString.stringify(query)}`
  )
export const updateGroup = (groupData: IGroupDetailed) =>
  safePut(`${groupUrl}/${groupData.name}`, groupData)
export const deleteGroup = (groupId: string) =>
  safeDelete(`${groupUrl}/${groupId}`)
export const getGroupCapabilitiesSummary = (
  groupId: string
): Promise<ICapabilitiesSummaryRaw> =>
  safeGet(`${groupUrl}/${groupId}/capabilities-summary`)

export const transformRolesInputToState = ({
  editorRole,
  ...inputs
}: IGroupInput): IGroupDetailed => ({
  ...inputs,
  roles: editorRole && {
    editors: {
      id: editorRole.id,
      name: editorRole.value,
    },
  },
})

export const transformRolesStateToInput = (
  state: IGroupDetailed
): IGroupInput => ({
  ...state,
  editorRole: state!.roles && {
    id: get(state, 'roles.editors.id', ''),
    value: get(state, 'roles.editors.name', ''),
    label: get(state, 'roles.editors.name', ''),
  },
})

export const checkIfIsLightGroup = (editionTypes: EditionType[]): boolean =>
  !(
    editionTypes.includes(EditionType.GraphicFolder) ||
    editionTypes.includes(EditionType.DataStreamData)
  )
